import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Card } from "@/components/ui/card";
import { Skeleton } from "@/components/ui/skeleton";
import { useQuery } from "@tanstack/react-query";
import { getFunnelAnalytics } from "@/lib/analytics";
interface AnalyticsDialogProps {
  funnelId: string;
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
}
export const AnalyticsDialog = ({
  funnelId,
  isOpen,
  onOpenChange
}: AnalyticsDialogProps) => {
  const {
    data: analytics,
    isLoading
  } = useQuery({
    queryKey: ['funnelAnalytics', funnelId],
    queryFn: () => getFunnelAnalytics(funnelId),
    enabled: isOpen,
    refetchInterval: 30000 // Refresh every 30 seconds when dialog is open
  });
  const conversionRate = analytics ? (analytics.submissions / analytics.visitors * 100).toFixed(1) : '0';
  return <Dialog open={isOpen} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[600px]">
        <DialogHeader>
          <DialogTitle>Oldal analitika</DialogTitle>
        </DialogHeader>
        
        <div className="space-y-6">
          {/* Metrics Cards */}
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
            <Card className="p-4">
              <h3 className="text-sm font-medium text-muted-foreground">Látogatók</h3>
              {isLoading ? <Skeleton className="h-8 w-20 mt-1" /> : <p className="text-2xl font-bold">{analytics?.visitors || 0}</p>}
            </Card>
            <Card className="p-4">
              <h3 className="text-sm font-medium text-muted-foreground">Űrlap kattintások</h3>
              {isLoading ? <Skeleton className="h-8 w-20 mt-1" /> : <p className="text-2xl font-bold">{analytics?.formClicks || 0}</p>}
            </Card>
            <Card className="p-4">
              <h3 className="text-sm font-medium text-muted-foreground">Beküldések</h3>
              {isLoading ? <Skeleton className="h-8 w-20 mt-1" /> : <p className="text-2xl font-bold">{analytics?.submissions || 0}</p>}
            </Card>
          </div>

          {/* Conversion Rate */}
          <Card className="p-4">
            <h3 className="text-sm font-medium text-muted-foreground mb-1">Konverziós ráta</h3>
            {isLoading ? <Skeleton className="h-8 w-20" /> : <p className="text-2xl font-bold">{conversionRate}%</p>}
          </Card>
        </div>
      </DialogContent>
    </Dialog>;
};